const FileDisplayNames = {
    'default': 'File',
    'application/pdf': 'PDF',
    'application/msword': 'Word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word',
    'image/png': 'Image',
    'image/jpg': 'Image',
    'image/jpeg': 'Image',
    'image/gif': 'Image',
    'video/mp4': 'Video',
    'video/webm': 'Video',
    'video/quicktime': 'Video',
    'video/mpeg': 'Video',
    'video/x-ms-wmv': 'Video',
    'video/avi': 'Video',
    'audio/mp3': 'Audio',
    'audio/mp4': 'Audio',
    'audio/mpeg': 'Audio',
    'audio/wav': 'Audio'
};
export default FileDisplayNames;
